import { useQuery } from "@tanstack/react-query";
import { getModels } from "@/lib/api";
import ModelCard from "@/components/site/ModelCard";

export default function Models() {
  const { data: models = [], isLoading, error } = useQuery({
    queryKey: ["models"],
    queryFn: getModels,
  });

  return (
    <div data-testid="page-models">
      <section className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-12">
        <p
          data-testid="models-eyebrow"
          className="text-[11px] uppercase tracking-[0.22em] text-emerald-700 font-semibold"
        >
          The full lineup
        </p>
        <h1
          data-testid="models-title"
          className="mt-3 font-heading text-5xl sm:text-6xl tracking-tight font-light text-slate-950"
        >
          Six low-speed electrics,
          <br />
          one clean idea.
        </h1>
        <p className="mt-6 max-w-2xl text-slate-600 leading-relaxed">
          Every model in our range is capped at a license-free 25 km/h and built
          on the same promise — clean energy, low cost, real reliability.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        {error && (
          <p data-testid="models-error" className="text-rose-600">
            Failed to load models. Please try again.
          </p>
        )}
        {isLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className={`animate-pulse rounded-3xl bg-slate-100 h-[460px] ${
                  i % 3 === 0 ? "md:col-span-8" : "md:col-span-4"
                }`}
              />
            ))}
          </div>
        ) : (
          <div
            data-testid="models-grid"
            className="grid grid-cols-1 md:grid-cols-12 gap-8"
          >
            {models.map((m, i) => (
              <ModelCard key={m.slug} model={m} featured={i % 3 === 0} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
